import { render, staticRenderFns } from "./DemoDatepickerMultiple.vue?vue&type=template&id=5824c27a&"
import script from "./DemoDatepickerMultiple.vue?vue&type=script&lang=js&"
export * from "./DemoDatepickerMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
installComponents(component, {VDatePicker})
